var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var LEFT = 37;
var UP = 38;
var RIGHT = 39;
var DOWN = 40;
var TAB = 9;
var ENTER = 13;
var ESCAPE = 27;
export default {
  methods: {
    showChange: function showChange(val) {
      this.show = val;
      if (val) {
        this.populate();
        this.findSelectionPage();
        this.inputFocus();
      } else {
        if (this.isSearch) {
          this.search = '';
          this.$refs.search.value = '';
        }
        this.highlight = -1;
      }
    },
    focus: function focus() {
      this.$el.click();
    },

    /**
     * remove all selected item
     */
    remove: function remove(index) {
      var removed = [];
      if (typeof index !== 'number') {
        removed = this.picked.slice();
        this.picked = [];
      } else {
        removed = [this.picked[index]];
        this.picked.splice(index, 1);
      }
      this.$emit('removed', removed);
    },

    /**
     * pick/remove current page items
     * @param check
     * true: pick
     * false: remove
     */
    pickPage: function pickPage() {
      var _this = this;

      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var toDo = [];
      if (check) {
        var _picked;

        // picked current page items
        if (this.maxSelectLimit && this.picked.length >= this.maxSelectLimit) return;
        var available = 0;

        /**
         * the number of current page available items
         */
        if (check && this.maxSelectLimit) {
          var outOfPage = this.picked.filter(function (val) {
            return _this.list.findIndex(function (value) {
              return val[_this.keyField] === value[_this.keyField];
            }) === -1;
          }).length;
          available = this.maxSelectLimit - outOfPage;
        }
        this.list.forEach(function (row) {
          if (!_this.inPicked(row) && (!_this.maxSelectLimit || _this.maxSelectLimit && toDo.length < available)) {
            toDo.push(row);
          }
        });
        (_picked = this.picked).push.apply(_picked, toDo);
      } else {
        // unpicked current page items
        if (!this.picked.length) return;
        this.list.forEach(function (row) {
          if (_this.inPicked(row)) {
            toDo.push(_this.inPickedIndex(row));
          }
        });
        this.$emit('removed', this.picked.filter(function (val, index) {
          return toDo.includes(index);
        }));
        this.picked = this.picked.filter(function (val, index) {
          return !toDo.includes(index);
        });
      }

      this.inputFocus();
    },
    getResults: function getResults() {
      if (!this.picked.length || this.multiple) return;
      return this.renderCell(this.picked[0]);
    },
    renderCell: function renderCell(row) {
      if (!row || !Object.keys(row).length) return '';
      switch (_typeof(this.showField)) {
        case 'string':
          return row[this.showField];
        case 'function':
          return this.showField(row);
      }
    },
    processKey: function processKey(e) {
      if (![LEFT, UP, RIGHT, DOWN, ESCAPE, ENTER, TAB].includes(e.keyCode)) this.populate();
    },
    processControl: function processControl(e) {
      if ([LEFT, UP, RIGHT, DOWN, ESCAPE, ENTER, TAB].includes(e.keyCode)) {
        switch (e.keyCode) {
          case LEFT:
            if (this.pagination) this.$refs.page.switchPage('previous');
            break;
          case UP:
            this.previous();
            break;
          case RIGHT:
            if (this.pagination) this.$refs.page.switchPage('next');
            break;
          case DOWN:
            this.next();
            break;
          case TAB:
          case ENTER:
            if (this.highlight !== -1) this.selectItem(this.list[this.highlight]);
            break;
          case ESCAPE:
            this.close();
            break;
        }
      }
    },
    previous: function previous() {
      var _this2 = this;

      if (this.highlight > 0 && this.list.length) {
        var previous = this.list.filter(function (val, idx) {
          return idx < _this2.highlight && !_this2.inPicked(val);
        });
        if (previous.length) {
          var preIndex = this.list.findIndex(function (val) {
            return Object.is(val, previous[previous.length - 1]);
          });
          if (preIndex !== -1) this.highlight = preIndex;
        }
      }
    },
    next: function next() {
      var _this3 = this;

      if (this.highlight < this.list.length - 1) {
        var nextIndex = this.list.findIndex(function (val, idx) {
          return idx > _this3.highlight && !_this3.inPicked(val);
        });
        if (nextIndex !== -1) this.highlight = nextIndex;
      }
    },
    selectItem: function selectItem(row) {
      var _this4 = this;

      if (this.inPicked(row)) return;
      // multiple selection by tag form
      if (this.multiple) {
        if (this.maxSelectLimit && this.picked.length < this.maxSelectLimit || !this.maxSelectLimit) {
          this.picked.push(row);
        } else {
          this.message = this.i18n.max_selected.replace('max_selected_limit', '<b>' + this.maxSelectLimit + '</b>');
          setTimeout(function () {
            _this4.message = '';
          }, 3000);
        }
        this.inputFocus();
      } else {
        this.close();
        this.picked = [row];
      }
      this.highlight = -1;
    },
    sortList: function sortList() {
      if (this.data && Array.isArray(this.data) && this.sort) {
        var sortArr = this.sort.split(' ');var sort = {};
        if (sortArr.length === 2) {
          sort.field = sortArr[0];
          sort.order = sortArr[1];
          this.sortedList = this.data.slice().sort(function (a, b) {
            var valA = a[sort.field];
            var valB = b[sort.field];var order = sort.order ? sort.order.toLowerCase() : 'asc';
            if (order === 'asc') {
              return typeof valA === 'number' ? valA - valB : String(valA).localeCompare(String(valB));
            } else if (order === 'desc') {
              return typeof valA === 'number' ? valB - valA : String(valB).localeCompare(String(valA));
            }
          });
        }
      }
    },
    populate: function populate() {
      var _this5 = this;

      if (this.data) {
        if (this.search && this.search !== this.lastSearch) this.pageNumber = 1;
        if (Array.isArray(this.data)) {
          var list = this.sortedList ? this.sortedList.slice() : this.data.slice();
          if (this.search) {
            // 搜索字典项
            list = list.filter(function (val) {
              var exp = new RegExp(_this5.search.toLowerCase());
              var sspell = val['sspell'] ? val['sspell'] : '';
              var fspell = val['fspell'] ? val['fspell'] : '';
              var name = val[_this5.showField] ? val[_this5.showField] : '';
              var code = val[_this5.keyField] ? val[_this5.keyField] : '';
              return exp.test(name.toLowerCase()) || exp.test(code.toLowerCase()) || exp.test(sspell.toLowerCase()) || exp.test(fspell.toLowerCase());
            });
          }
          this.totalRows = list.length;

          if (this.pagination) {
            var start = (this.pageNumber - 1) * this.pageSize;
            var end = start + this.pageSize - 1;
            this.list = list.filter(function (val, index) {
              return index >= start && index <= end;
            });
          } else {
            this.list = list;
          }
        } else {
          console.log('数据格式错误');
        }

        this.lastSearch = this.search;
        this.highlight = -1;
      }
      this.inputFocus();
    },
    pageChange: function pageChange(pNum) {
      this.pageNumber = pNum;
      this.populate();
    },
    initSelection: function initSelection() {
      var _this6 = this;

      if (this.data.length >= this.pageSize) {
        this.pagination = true;
      }
      // 计算字典
      if (this.value) {
        if (Array.isArray(this.data)) {
          var arr = this.value.split(',');
          if (arr && arr.length) {
            var matchRows = this.data.filter(function (val) {
              return arr.includes(String(val[_this6.keyField]));
            });
            if (matchRows.length) this.picked = this.multiple ? matchRows : [matchRows[0]];
          }
          this.findSelectionPage();
        } else {
          console.log('数据格式错误');
        }
      }
      this.populate();
    },
    findSelectionPage: function findSelectionPage() {
      var _this7 = this;

      if (!this.multiple && this.pagination) {
        var list = this.sortedList ? this.sortedList.slice() : this.data.slice();
        var index = list.findIndex(function (val) {
          return String(val[_this7.keyField]) === _this7.value;
        });
        if (index >= 0) {
          this.pageNumber = Math.ceil((index + 1) / this.pageSize);
        }
      } else if (this.multiple && this.pagination) {
        // 多选，默认跳转第一选择项
        var _list = this.sortedList ? this.sortedList.slice() : this.data.slice();
        if (this.picked && this.picked.length > 0) {
          var key = this.picked[this.picked.length - 1][this.keyField];
          var _index = _list.findIndex(function (val) {
            return String(val[_this7.keyField]) === key;
          });
          if (_index >= 0) {
            this.pageNumber = Math.ceil((_index + 1) / this.pageSize);
          }
        }
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/mixins/methods.js
// module id = 18
// module chunks = 0